import React from "react";
import { APP_NAME } from "../../brand";

type BrandMarkProps = {
  size?: number;
  className?: string;
  label?: string;
};

/**
 * The app icon (public/icon.svg) used as a brand glyph.
 * Prefer this over a generic suit icon anywhere the mark stands for the app.
 */
const BrandMark: React.FC<BrandMarkProps> = ({ size = 20, className, label }) => (
  <img
    src={`${process.env.PUBLIC_URL}/icon.svg`}
    width={size}
    height={size}
    className={className}
    alt={label ?? APP_NAME}
    aria-hidden={label ? undefined : true}
    draggable={false}
    style={{ flexShrink: 0, display: "block", objectFit: "contain" }}
  />
);

export default BrandMark;
